// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container--3DLTW"};